type Params = {
  datetime: Date;
  variant?: "school" | "premier" | "press";
  customNote?: string;
  outdated?: boolean;
};

export default function CalendarItem({ datetime, outdated = false, variant, customNote }: Params) {
  // {"datetime":"2024-07-14T18:07:00.000Z"}
  const monthNames = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];
  const weekDays = ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"];

  const today = new Date();

  function getWeekLabel(date: Date) {
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    if (date.toDateString() === today.toDateString()) return "Hoje";
    if (date.toDateString() === tomorrow.toDateString()) return "Amanhã";
    return weekDays[date.getDay()];
  }

  const year = datetime.getFullYear();
  const isDifferentYear = year !== today.getFullYear();
  const displyYear = isDifferentYear ? ` '${String(year).slice(2, 4)}` : "";

  const month = monthNames[datetime.getMonth()];
  const day = datetime.getDate();
  const hour = datetime.toLocaleTimeString("pt-PT", {
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "UTC",
  });
  const weeklabel = getWeekLabel(datetime);

  return (
    <div className={outdated ? "opacity-50" : ""}>
      <div className="bg-white border border-gray-200 w-[64px] shadow-xs rounded overflow-hidden">
        <div className="bg-red-600 text-white font-medium text-center text-sm py-1">
          {month}
          {displyYear}
        </div>
        <div className="bg-white text-gray-800 font-bold text-center text-xl pt-1">{day}</div>
        <div className="bg-white text-gray-600 font-bold text-center text-sm pb-1">{hour}</div>
        <div className="bg-gray-100 text-gray-500 font-bold text-center text-xs py-1">{weeklabel}</div>
      </div>
    </div>
  );
}
